import { FLAT_FORM_FIELD_NAME_INHABITANT } from '../../FlatForm.constants'

export function getInhabitantFieldApiParams(contractsList) {
  return {
    exclude_value: contractsList.map(
      contract => contract[FLAT_FORM_FIELD_NAME_INHABITANT]?.value
    ),
  }
}
